
    import './styles.scoped.css';
    export default {
  "option": "awsui_option_1p2cx_w1alb_5",
  "disabled": "awsui_disabled_1p2cx_w1alb_20",
  "content": "awsui_content_1p2cx_w1alb_24",
  "label-content": "awsui_label-content_1p2cx_w1alb_31",
  "label": "awsui_label_1p2cx_w1alb_31",
  "tag": "awsui_tag_1p2cx_w1alb_38",
  "label-tag": "awsui_label-tag_1p2cx_w1alb_39",
  "label-prefix": "awsui_label-prefix_1p2cx_w1alb_50",
  "tags": "awsui_tags_1p2cx_w1alb_63",
  "description": "awsui_description_1p2cx_w1alb_64",
  "icon": "awsui_icon_1p2cx_w1alb_81",
  "icon-size-big": "awsui_icon-size-big_1p2cx_w1alb_88",
  "filtering-match-highlight": "awsui_filtering-match-highlight_1p2cx_w1alb_92",
  "trigger-variant": "awsui_trigger-variant_1p2cx_w1alb_107"
};
  